import { Routes } from '@angular/router';

import { MestradoComponent } from './mestrado.component';

export const MESTRADO_ROUTER: Routes = [
  {
    path: 'mestrado',
    component: MestradoComponent,
    data: {
      meta: {
        title: 'Mestrado no Ceuma',
        description: 'Conheça os cursos da melhor Universidade do Maranhão',
      },
    },
  },
];
